import React from 'react';
import NumberToWords from 'number-to-words';

const BillPrint = ({ labelData }) => {
    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        // fontSize: '12px',
    };


    const cellStyleh = {
        border: '1px solid #000',
        padding: '5px',
        textAlign: 'center',
        // fontSize: '11px',
        fontWeight: 'normal'
    };

    const cellStyle = {
        fontSize: '12px',
        borderLeft: '1px solid black', // only vertical lines
        borderRight: '1px solid black', // only vertical lines
        textAlign: 'left',
        padding: '4px',
        height: '24px'
    };

    const cellStyleR = {
        fontSize: '12px',
        borderLeft: '1px solid black', // only vertical lines
        borderRight: '1px solid black', // only vertical lines
        textAlign: 'right',
        padding: '4px',
        height: '24px'
    };


    const cellStyleHeader = {
        fontSize: '11px',
        border: '1px solid black',
        textAlign: 'center',
        padding: '4px',
    };

    const cellStyleTotal = {
        fontSize: '10px',
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        textAlign: 'right',
        padding: '4px',
    };



    const cellLeft = {
        border: '1px solid #000',
        padding: '5px',
        textAlign: 'left',
    };


    const tableBorder = '1px solid black';
    const text12 = { fontSize: '12px' };
    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num === 10) return tens[1];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 !== 0 ? ' ' + convert(num % 1000) : '');
            if (num < 1000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 !== 0 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num).trim();
    };


    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',                   
                    padding: '2px 4px',
                    minHeight: '15px',
                    fontSize: '13px',
                    position: 'relative',
                    height: '15px'
                }}
            >
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    if (!labelData?.ProformaPrint) return null;

    const header = labelData.ProformaPrint;
    const items = labelData.ProformaPrintItems || [];

    return (
        <div
            style={{
                width: '100%',
                maxWidth: '800px',
                margin: 'auto',
                fontFamily: 'Arial, sans-serif',
                border: tableBorder,
                padding: '0',
            }}
        >
            {/* Company Header */}
            <div
                style={{
                    textAlign: 'center',
                    borderBottom: tableBorder,
                    padding: '6px',
                    lineHeight: '1.3',
                }}
            >
                <h3 style={{ margin: '2px', fontWeight: 'bold' }}>{header.CompanyName}</h3>
                <div style={text12}>
                    {header.CompanyAddressLine}
                    <br />
                    {header.CompanyContactNumber1}
                </div>
                <div style={{ ...text12, fontWeight: 'bold', marginTop: '4px' }}>
                    GST NO : {header.CompanyGSTNumber} <br />
                    State : {header.BranchStateName} - {header.BranchStateCode}
                </div>
            </div>

            {/* Invoice Header Row */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTop: tableBorder,
                    borderBottom: tableBorder,
                    padding: '8px 10px',
                    minHeight: '20px',
                    fontSize: '13px',
                    position: 'relative',
                }}
            >
                {/* Left: Invoice No */}
                <div style={{ textAlign: 'left' }}>
                    Invoice No : {header.BillPrefix}/{header.BillNumber}/{header.FinYear}
                </div>

                {/* Center: TAX INVOICE */}
                <div
                    style={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                    }}
                >
                    PROFORMA
                </div>

                {/* Right: Date */}
                <div style={{ textAlign: 'right' }}>
                    Date : {new Date(header.BillDate).toLocaleDateString('en-GB')}
                </div>
            </div>


            {/* Customer Info */}
            <div style={{ display: 'flex', borderBottom: tableBorder, ...text12 }}>
                <div style={{ flex: 2, borderRight: tableBorder, padding: '5px' }}>
                    <strong>Customer Name & Address</strong>
                    <br />
                    {header.CustomerName}
                    <br />
                    {header.CustomerAddress}
                    <br />
                    {header.CustomerContactNumber}
                </div>
                <div style={{ flex: 1, padding: '5px' }}>
                    <div>State : {header.CustomerStateCode} - {header.CustomerStateName}</div>
                    <div>GST NO : {header.CustomerGSTNumber}</div>
                </div>
            </div>
            <table
                style={{
                    borderCollapse: 'collapse',
                    width: '100%',
                    marginTop: '0px',
                    borderLeft: '1px solid black',
                    borderRight: '1px solid black',
                }}
            >
                <thead>
                    <tr>
                        <th rowSpan="2" style={{ width: '5%', fontSize: '11px', border: '1px solid black' }}>HSN</th>
                        <th rowSpan="2" style={{ width: '20%', fontSize: '11px', border: '1px solid black' }}>Description</th>
                        <th rowSpan="2" style={{ width: '7%', fontSize: '11px', border: '1px solid black' }}>Unit Price</th>
                        <th rowSpan="2" style={{ width: '7%', fontSize: '11px', border: '1px solid black' }}>Dis Amt</th>
                        <th rowSpan="2" style={{ width: '10%', fontSize: '11px', border: '1px solid black' }}>Taxable Rate</th>
                        <th rowSpan="2" style={{ width: '5%', fontSize: '11px', border: '1px solid black' }}>Qty</th>
                        <th rowSpan="2" style={{ width: '8%', fontSize: '11px', border: '1px solid black' }}>Taxable Amt</th>
                        <th colSpan="2" style={{ fontSize: '11px', border: '1px solid black' }}>CGST</th>
                        <th colSpan="2" style={{ fontSize: '11px', border: '1px solid black' }}>SGST</th>
                        <th colSpan="2" style={{ fontSize: '11px', border: '1px solid black' }}>IGST</th>
                        <th rowSpan="2" style={{ width: '10%', fontSize: '11px', border: '1px solid black' }}>Total</th>
                    </tr>
                    <tr>
                        <th style={{ width: '3%', fontSize: '11px', border: '1px solid black' }}>%</th>
                        <th style={{ width: '5%', fontSize: '11px', border: '1px solid black' }}>Amt</th>
                        <th style={{ width: '3%', fontSize: '11px', border: '1px solid black' }}>%</th>
                        <th style={{ width: '5%', fontSize: '11px', border: '1px solid black' }}>Amt</th>
                        <th style={{ width: '3%', fontSize: '11px', border: '1px solid black' }}>%</th>
                        <th style={{ width: '5%', fontSize: '11px', border: '1px solid black' }}>Amt</th>
                    </tr>
                </thead>

                <tbody>
                    {items.map((item, idx) => (
                        <tr key={idx} style={{ height: '24px' }}>
                            <td style={cellStyle}>{item.HSNCode || '\u00A0'}</td>
                            <td style={cellStyle}>{item.ItemName || '\u00A0'}</td>
                            <td style={cellStyleR}>{item.Rate ? item.Rate.toFixed(2) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.DiscountAmount ? item.DiscountAmount.toFixed(2) : '\u00A0'}</td>
                            <td style={cellStyleR}>
                                {item.Quantity
                                    ? (item.TaxableAmount / item.Quantity).toFixed(2)
                                    : '\u00A0'}
                            </td>

                            <td style={cellStyleR}>{item.Quantity || '\u00A0'}</td>
                            <td style={cellStyleR}>{item.TaxableAmount ? item.TaxableAmount.toFixed(2) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.GSTRate ? (item.GSTRate / 2).toFixed(1) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.CGSTAmount ? item.CGSTAmount.toFixed(2) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.GSTRate ? (item.GSTRate / 2).toFixed(1) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.SGSTAmount ? item.SGSTAmount.toFixed(2) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.IGSTRate ? item.IGSTRate.toFixed(1) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.IGSTAmount ? item.IGSTAmount.toFixed(2) : '\u00A0'}</td>
                            <td style={cellStyleR}>{item.TotalAmount ? item.TotalAmount.toFixed(2) : '\u00A0'}</td>
                        </tr>
                    ))}

                    {/* Empty Rows */}
                    {[...Array(3)].map((_, i) => (
                        <tr key={`blank-${i}`}>
                            {Array(14).fill().map((_, j) => (
                                <td
                                    key={j}
                                    style={{
                                        borderLeft: '1px solid black',
                                        borderRight: '1px solid black',
                                        height: '24px',
                                        padding: '4px'
                                    }}
                                >
                                    &nbsp;
                                </td>
                            ))}
                        </tr>
                    ))}

                    {/* Total Row */}
                    <tr style={{ fontWeight: 'bold', fontSize: '12px', backgroundColor: '#f2f2f2', border: '1px solid black' }}>
                        <td colSpan="5" style={{ textAlign: 'center', border: '1px solid black' }}>Total</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>
                            {items.reduce((sum, i) => sum + (i.Quantity || 0), 0)}
                        </td>
                        <td style={{ textAlign: 'right', border: '1px solid black' }}>
                            {items.reduce((sum, i) => sum + (i.TaxableAmount || 0), 0).toFixed(2)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: 'right', border: '1px solid black' }}>
                            {items.reduce((sum, i) => sum + (i.CGSTAmount || 0), 0).toFixed(2)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: 'right', border: '1px solid black' }}>
                            {items.reduce((sum, i) => sum + (i.SGSTAmount || 0), 0).toFixed(2)}
                        </td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'right', border: '1px solid black' }}>
                            {items.reduce((sum, i) => sum + (i.TotalAmount || 0), 0).toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>


            {/* Bank / QR / Totals Section */}
            < div style={{ display: 'flex', borderTop: '1px solid black', fontSize: '12px', marginTop: '0px' }}>

                {/* Bank Details */}
                <div style={{ flex: 1, borderRight: '1px solid black', padding: '5px' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '100px', fontWeight: 'bold' }}>Bank Name</div>
                        <div>: INDUSIND BANK</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '100px', fontWeight: 'bold' }}>A/C No</div>
                        <div>: 257902822985</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '100px', fontWeight: 'bold' }}>IFSC Code</div>
                        <div>: {header.IFSCCODE}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '100px', fontWeight: 'bold' }}>Branch</div>
                        <div>: {header.BankBranchName}</div>
                    </div>
                </div>


                {/* QR Code */}
                < div style={{ flex: 1, borderRight: '1px solid black', padding: '5px', textAlign: 'center' }}>
                    {/* Replace with your QR image */}
                    {/* < img src={header.QRCodeUrl} alt="QR Code" style={{ width: '100px', height: '100px' }} /> */}
                </div >

                {/* Totals */}

                <div style={{ flex: 1, padding: '5px', marginRight: '10px', fontSize: '13px' }}>
                    {[
                        { label: 'Taxable Amount', value: header.TaxableAmount },
                        { label: 'CGST ', value: header.CGSTAmount },
                        { label: 'SGST ', value: header.SGSTAmount },
                        { label: 'IGST ', value: header.IGSTAmount },
                        { label: 'Round Off', value: header.RoundOff },
                    ].map((item, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '115px 10px 120px', // label, colon, value
                                alignItems: 'center',
                                marginBottom: '2px',
                            }}
                        >
                            <div style={{ fontWeight: 'bold' }}>{item.label}</div>
                            <div style={{ textAlign: 'center' }}>:</div>
                            <div style={{ textAlign: 'right', marginRight: '-11px' }}>{item.value?.toFixed(2)}</div>
                        </div>
                    ))}

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '115px 10px 120px',
                            alignItems: 'center',
                            marginTop: '5px',
                            borderTop: '1px solid #000',
                            paddingTop: '4px',
                            fontWeight: 'bold',
                        }}
                    >
                        <div>Grand Total</div>
                        <div style={{ textAlign: 'center' }}>:</div>
                        <div style={{ textAlign: 'right', fontWeight: 'bold', marginRight: '-11px' }}>
                            {header.GrandTotal?.toFixed(2)}
                        </div>
                    </div>
                </div>



            </div >

            {/* Amount in Words */}
            < div style={{ borderTop: '1px solid black', padding: '1px', fontSize: '13px' }}>
                {/* <AmountInWords amount={header.GrandTotal} /> */}
                < AmountInWords amount={header.GrandTotal} />

            </div >


            {/* Signature Section */}
            <div
                style={{
                    borderTop: '1px solid black',
                    padding: '20px 5px',
                    fontSize: '13px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end', // ✅ moves both to the right side
                    textAlign: 'right'
                }}
            >
                <div><strong>For {header.CompanyName}</strong></div>
                <div style={{ marginTop: '40px' }}><strong>Authorised Signatory</strong></div>
            </div>

            <style>
                {`
                    @media print {
                        @page {
                            margin: 10;
                        }
                        body {
                            margin: 15px;
                        }
                    }
                `}
            </style>

        </div >
    );
};

export default BillPrint;
